import setClauseValue from '../actions/setClauseValue';
import InboxRuleFolderType from '../store/schema/InboxRuleFolderType';
import getCustomIcon from '../actions/helpers/getCustomIcon';
import { observer } from 'mobx-react';
import strings from 'owa-strings/owa-mail-strings';
import * as React from 'react';
import store from '../store/store';
import { getMoveToMenuProps } from 'owa-mail-moveto-control';
import createNewFolder from '../actions/createNewFolderInboxRules';
import getFolderFromId from '../utils/folderTypeConversionUtil';
import { DefaultButton } from 'office-ui-fabric-react/lib/Button';
import { IButton } from 'office-ui-fabric-react/lib/components/Button';
import setFocusedClauseId from '../actions/helpers/setFocusedClauseId';
import { DirectionalHint } from 'office-ui-fabric-react/lib/Tooltip';

const styles = require('./InboxRuleClause.scss');

export interface InboxRulesFolderDropdownProps {
    clauseId: string;
}

@observer
export default class InboxRulesFolderDropdown extends React.Component<
    InboxRulesFolderDropdownProps,
    {}
> {
    private buttonRef: IButton;

    render() {
        let currentSelectedFolder = store.inboxRulesEditState.clauseMap.get(this.props.clauseId)
            .clauseValue as InboxRuleFolderType;

        let moveToFolderProps = getMoveToMenuProps({
            supportedMoveToMailboxContexts: ['primary'],
            shouldShowSearchBox: true /* shouldShowSearchBox */,
            actionSource: 'RuleOptions',
            createNewFolder: createNewFolder,
            dismissMenu: () => {
                // we must explicitly call dismissMenu from the button ref because it does not close when focus is lost
                this.buttonRef.dismissMenu();
                setFocusedClauseId(this.props.clauseId, false /* shouldSetAsFocused */);
            },
            onFolderClick: folderId => {
                setClauseValue(getFolderFromId(folderId), this.props.clauseId);
                this.buttonRef.dismissMenu();
            },
            getCustomIcon: getCustomIcon,
            directionalHint: DirectionalHint.topCenter,
            useTargetWidth: true,
            coverTarget: true,
        });

        let buttonStyles = {
            root: styles.categoryMoveToPickerButton,
            label: currentSelectedFolder
                ? styles.categoryMoveToPickerText
                : styles.categoryMoveToPickerPlaceholderText,
        };

        return (
            <DefaultButton
                componentRef={ref => {
                    this.buttonRef = ref;
                }}
                styles={buttonStyles}
                className={styles.categoryMoveToPickerButton}
                menuProps={moveToFolderProps}
                text={
                    currentSelectedFolder
                        ? currentSelectedFolder.displayName
                        : strings.ruleSelectFolder
                }
                iconProps={
                    currentSelectedFolder && {
                        iconName: getCustomIcon(currentSelectedFolder.folderId, true),
                    }
                }
            />
        );
    }
}
